import { FiatCurrency } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';

export const useMangopayCreditCardsEnabled = () => {
  const {
    fiatCurrency: { code },
  } = useCurrentUserContext();
  return code !== FiatCurrency.USD;
};
